import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/apiClient";

export function SupplierNewPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    code: "",
    name: "",
    contactEmail: "",
    contactPhone: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await api.createSupplier({
        code: form.code.trim(),
        name: form.name.trim(),
        contactEmail: form.contactEmail.trim() || undefined,
        contactPhone: form.contactPhone.trim() || undefined,
      });
      navigate("/app/suppliers");
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Could not create supplier");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <div>
        <h2 className="page-title">New supplier</h2>
        <p className="page-subtitle">Code will be stored uppercase.</p>
      </div>
      <form className="card" onSubmit={handleSubmit} style={{ maxWidth: 560 }}>
        {error ? <div className="alert error full">{error}</div> : null}
        <div className="field">
          <label htmlFor="sc">Code *</label>
          <input
            id="sc"
            required
            maxLength={48}
            value={form.code}
            onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))}
          />
        </div>
        <div className="field">
          <label htmlFor="sn">Name *</label>
          <input
            id="sn"
            required
            maxLength={200}
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          />
        </div>
        <div className="field">
          <label htmlFor="se">Contact email</label>
          <input
            id="se"
            type="email"
            value={form.contactEmail}
            onChange={(e) => setForm((f) => ({ ...f, contactEmail: e.target.value }))}
          />
        </div>
        <div className="field">
          <label htmlFor="sp">Contact phone</label>
          <input
            id="sp"
            value={form.contactPhone}
            onChange={(e) => setForm((f) => ({ ...f, contactPhone: e.target.value }))}
          />
        </div>
        <div className="button-row">
          <button className="button" type="submit" disabled={submitting}>
            {submitting ? "Saving…" : "Create supplier"}
          </button>
        </div>
      </form>
    </section>
  );
}
